import React, { useReff } from "react";
import api from "../../configs/api";
import Swal from "sweetalert2";
import { Close } from "@mui/icons-material";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    DialogContentText,
    Box,
    IconButton,
    TextField,
} from "@mui/material";

import ClearIcon from "@mui/icons-material/Clear";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import BackupIcon from "@mui/icons-material/Backup";
// import "react-datepicker/dist/react-datepicker.css";
import Flatpickr from "react-flatpickr";
import { makeStyles } from "@material-ui/core/styles";
import { set } from "react-hook-form";

const useStyles = makeStyles({
    paperFullWidth: {
        overflowY: "visible",
    },
    dialogContentRoot: {
        overflowY: "visible",
    },
    topScrollPaper: {
        marginTop: "-60px",
    },
    topPaperScrollBody: {
        verticalAlign: "top",
        marginTop: "50px",
    },
});

const UploadData = ({ show, handleClose, datas }) => {


    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        title: "left-gap",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,

        didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
    });

    const [activity, setActivity] = React.useState("");
    const [dateRange, setDateRange] = React.useState([]);
    const [disableDownload, setDisableDownload] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const classes = useStyles();
    const formatDate = (date) => {
        let formattedDate = date.toLocaleDateString("en-SE", {
            timeZone: "Asia/Bangkok",
        });
        // date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

        return formattedDate;
    };
    const [valuess, setValues] = React.useState({
        description: "",
        calculation_id: "",
        fromTo: "",
        sku: datas ? datas : [],
        periodFrom: "",
        periodTo: "",
    });
    const onResetValues = () => {
        setActivity("");
        setDateRange([]);
        setValues({
            description: "",
            calculation_id: "",
            fromTo: "",
            sku: datas ? datas : [],
            periodFrom: "",
            periodTo: "",
        });
        setLoading(false);
        handleClose();
    };
    const onHandleChange = (e) => {
        if (e.target) {
            if (e.target.value === "" || e.target.value === null) {
                console.log("empty");

                setValues({ ...valuess, [e.target.name]: e.target.value });
            } else if (e.target.type === "text") {
                const { name, value } = e.target;
                setValues({ ...valuess, [name]: value });
            }
        } else {
            if (e.length > 0) {
                return setDateRange([
                    formatDate(e[0]),
                    formatDate(e[1]) ? formatDate(e[1]) : formatDate(e[0]),
                ]);
            }
            return setDateRange([]);
        }
    };
    const submitDownload = async () => {
        console.log({
            description: valuess.description,
            calculation_id: valuess.calculation_id,
            period_from: dateRange[0],
            period_to: dateRange[1],
            sku: datas,
        });
        setLoading(true);
        // await api
        //     .post("/api/report/detail_result_queue", {
        //         description: valuess.description,
        //         calculation_id: valuess.calculation_id,
        //         periodFrom: dateRange[0],
        //         periodTo: dateRange[1],
        //         sku: datas,
        //     })
        //     .then((res) => {
        //         console.log(res);
        //         if (res.data.status === 200) {
        //             Toast.fire({
        //                 icon: "success",
        //                 title: res.data.message,
        //             });
        //             setTimeout(() => {
        //                 setLoading(false);
        //                 onResetValues();
        //             }, 3000);
        //         } else {
        //             Toast.fire({
        //                 icon: "error",
        //                 title: res.data.message,
        //             });
        //             setLoading(false);
        //             onResetValues();
        //         }
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //         Toast.fire({
        //             icon: "error",
        //             title: err.message,
        //         });
        //         setLoading(false);
        //         onResetValues();
        //     });
    };

    return (
        <Dialog
            PaperProps={{ style: { overflowY: "visible" } }}
            classes={{
                paperFullWidth: classes.paperFullWidth,
                dialogPaper: classes.paperFullWidth,
                scrollPaper: classes.topScrollPaper,
                paperScrollBody: classes.topPaperScrollBody,
            }}
            onClose={onResetValues}
            aria-labelledby="customized-dialog-title"
            open={show}
        >
            <DialogTitle id="customized-dialog-title" onClose={onResetValues}>
                Upload Data
                <IconButton
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    onClick={onResetValues}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent
                style={{ overflowY: "visible" }}
                classes={{
                    root: classes.dialogContentRoot,
                    dialogPaper: classes.paperFullWidth,
                }}
                dividers
            >
                <DialogContentText>{`Total: ${datas.length} SKUs`}</DialogContentText>
                Process to upload data?
                If any error, please contact admin.
            </DialogContent>
            <DialogActions
                style={{
                    display: "flex",
                    justifyContent: "space-around",
                    padding: "1rem 1.5rem",
                }}
            >
                <Button
                    autoFocus
                    onClick={onResetValues}
                    color="error"
                    variant="outlined"
                    endIcon={<ClearIcon />}
                    style={{
                        marginRight: "1rem",
                    }}
                >
                    cancel
                </Button>
                <Button
                    style={{
                        marginLeft: "1rem",
                    }}
                    autoFocus
                    onClick={(e) => {
                        submitDownload();
                    }}
                    disabled={
                        valuess.description !== "" && dateRange.length > 0 && !loading
                            ? false
                            : true
                    }
                    color="primary"
                    variant="outlined"
                    endIcon={<BackupIcon />}
                >
                    {loading ? "Loading..." : "Upload Data"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default UploadData;
